var React = require('react');
var ReactRouter = require('react-router');
var Shopify = require('./shopify');
var ProductRow = require('./product-row');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  remainingRows: [],

  getInitialState: function() {
    return { rows: [] }
  },

  componentDidMount: function() {
    jQuery(this.refs.loadMore.getDOMNode()).css('display', 'none');
    Shopify.search(this.props.params.terms, this.searchResultGot);
    this.scrollToTop('search-result-page');
  },

  searchResultGot: function(result) {
    var title = 'search result for "' + this.props.params.terms + '"';
    if (0 == result.product.length) {
      title = 'no result for "' + this.props.params.terms + '"';
    }
    var rowOf3s = _.chunk(result.product, 3);
    var first4 = _.take(rowOf3s, 4);

    this.remainingRows = _.drop(rowOf3s, 4);

    var first = 0;
    this.setState({ title: title,
                    rows: first4.map(function(threeProd) {
                              var key = _.reduce(threeProd, function(result, prod) {
                                            result += prod.handle;
                                            return result;
                              }, "");
                              first++;
                              return <ProductRow collection={""} products={threeProd} 
                                                 noFade={1 == first ? true : false}
                                                 key={key} />
                          }.bind(this))});
    this.checkHideLoadMore();
    if (this.remainingRows.length) {
      jQuery(this.refs.loadMore.getDOMNode()).removeClass('hide');
    }
  },

  loadMore: function() {
    var curRows = this.state.rows;

    curRows = curRows.concat(this.remainingRows.map(function(threeProd) {
                  return <ProductRow collection={""} products={threeProd}
                                     history={this.history} />
    }.bind(this)));
    this.setState({ rows: curRows});
    jQuery(this.refs.loadMore.getDOMNode()).addClass('hide');
  },

  checkHideLoadMore: function() {
    if (0 == this.remainingRows.length) {
      jQuery(this.refs.loadMore.getDOMNode()).css('display', 'none');
    } else {
      jQuery(this.refs.loadMore.getDOMNode()).css('display', 'block');
    }
  },

  render: function() {
  	return <main id="content" className="container" role="main">
            <h1>{this.state.title}</h1>
                {this.state.rows}
            <div id="load-more-wrap">
                <button ref="loadMore" id="load-more" className="btn btn-primary btn-wide hide"
                        onClick={this.loadMore}>SEE ALL</button>
            </div>        
        </main>
  }
});